 /* global BrowserPrint */
 import React, { useState, useEffect } from 'react';
 import {
   Modal,
   Box,
   Typography,
   Grid,
   TextField,
   Button
 } from '@mui/material';

import { gerarEtiquetas2 } from '../services/api'; // já aponta p/ /api/gerar-etiquetas/
 import CheckCircleIcon from '@mui/icons-material/CheckCircle';
 import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

 const ImpEtiquetasModal = ({ open, client, onClose }) => {
   const [jobName, setJobName] = useState('');
   const [size, setSize] = useState('');
   const [qtyPerBox, setQtyPerBox] = useState('');
   const [numLabels, setNumLabels] = useState('');
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [submitSuccess, setSubmitSuccess] = useState(false);
   const [error, setError] = useState(null);

   useEffect(() => {
     if (!open) {
       // limpar estado quando fechar
       setJobName('');
       setSize('');
       setQtyPerBox('');
       setNumLabels('');
       setIsSubmitting(false);
       setSubmitSuccess(false);
       setError(null);
     }
   }, [open]);

   const enviarZPLParaImpressora = (zpl) => {
     BrowserPrint.getDefaultDevice("printer", printer => {
       if (printer) {
         printer.send(zpl, () => {
           console.log("Etiqueta enviada com sucesso");
         }, err => console.error("Erro na impressora:", err));
       } else {
         console.error("Impressora não encontrada");
       }
     });
   };

   const handleSubmit = async () => {
    if (!jobName || !size || !qtyPerBox || !numLabels) {
      setError('Preencha todos os campos.');
      return;
    }
    setIsSubmitting(true);
    setError(null);
  
    try {
      const { data } = await gerarEtiquetas2({
        client_id: client.id,
        job_name: jobName,
        tamanho: size,
        quantidade_por_caixa: qtyPerBox,
        quantidade_etiquetas: numLabels
      });
      console.log('Resposta gerarEtiquetas2:', data);
      setSubmitSuccess(true);
      for (let i = 0; i < data.quantidade_etiquetas; i++) {
        enviarZPLParaImpressora(data.zpl);
      }
      setTimeout(() => {
        setSubmitSuccess(false);
        onClose();
      }, 1500);
    } catch (err) {
      console.error('Erro ao gerar etiquetas:', err);
      setError('Falha ao gerar etiquetas.');
    } finally {
      setIsSubmitting(false);
    }
  };

   return (
     <Modal open={open} onClose={onClose}>
       <Box sx={{
         position: 'absolute', top: '50%', left: '50%',
         transform: 'translate(-50%, -50%)',
         width: 380, bgcolor: 'background.paper',
         borderRadius: 2, boxShadow: 24, p: 3
       }}>
         <Typography variant="h6" gutterBottom>
           Etiquetas para: {client?.nome2 || client?.name}
         </Typography>

         <Grid container spacing={2}>
           <Grid item xs={12}>
             <TextField
               label="Nome do Trabalho"
               fullWidth
               value={jobName}
               onChange={e => setJobName(e.target.value)}
             />
           </Grid>
           <Grid item xs={6}>
             <TextField
               label="Tamanho"
               fullWidth
               value={size}
               onChange={e => setSize(e.target.value)}
             />
           </Grid>
           <Grid item xs={6}>
             <TextField
               label="Qtde por Caixa"
               type="number"
               fullWidth
               value={qtyPerBox}
               onChange={e => setQtyPerBox(e.target.value)}
             />
           </Grid>
           <Grid item xs={12}>
             <TextField
               label="Número de Etiquetas"
               type="number"
               fullWidth
               value={numLabels}
               onChange={e => setNumLabels(e.target.value)}
             />
           </Grid>

           {error && (
             <Grid item xs={12}>
               <Typography color="error">{error}</Typography>
             </Grid>
           )}

           <Grid item xs={12} sx={{ textAlign: 'right' }}>
             <Button onClick={onClose} sx={{ mr: 1 }}>Cancelar</Button>
             <Button
               variant="contained"
               onClick={handleSubmit}
               disabled={isSubmitting || submitSuccess}
             >
               {isSubmitting
                 ? <HourglassEmptyIcon fontSize="small" />
                 : submitSuccess
                   ? <CheckCircleIcon />
                   : 'Gerar Etiquetas'
               }
             </Button>
           </Grid>
         </Grid>
       </Box>
     </Modal>
   );
 };

 export default ImpEtiquetasModal;
